import { useTranslation } from 'react-i18next';

export function getFileSizeString({ bytes, decimals = 0 }: { bytes: number; decimals?: number }): string {
  const { t } = useTranslation();
  const suffixes: string[] = [t('byte'), t('kilobyte'), t('megabyte'), t('gigabyte'), 'Тb'];
  if (bytes === 0) return `0${suffixes[0]}`;
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));

  return `${(bytes / Math.pow(1024, i)).toFixed(decimals)} ${suffixes[i]}`;
}
